export const TEST_ID = 'resourceAddButton';
